import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert, Col, Row } from "components/bootstrap";
import { LICENSE_SUBJECTS } from "license/constants";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
const EnterpriseLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/enterprise", rel: "noopener noreferrer" }, children);
const licenseStatus = (status) => {
  if (status.valid) {
    return "valid";
  }
  if (status.expired) {
    return "expired";
  }
  return "invalid";
};
const useInUse = (usesFilters, usesParameters) => {
  const { t } = useTranslation("enterprise_common");
  if (usesParameters && usesFilters) {
    return t("missing_license.in_use_parameter_and_filters");
  }
  return usesFilters ? t("missing_license.in_use_filters") : t("missing_license.in_use_parameter");
};
const MissingEnterpriseLicense = ({ usesFilters, usesParameters }) => {
  const { t } = useTranslation("enterprise_common");
  const productName = useProductName();
  const { data, isInitialLoading: isLoading } = useLicenseValidityForSubject(LICENSE_SUBJECTS.views);
  const inUse = useInUse(usesFilters, usesParameters);
  if (isLoading) return null;
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "danger",
      title: t("missing_license.title", {
        productName,
        status: t(`missing_license.status_${licenseStatus(data)}`)
      })
    },
    /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "missing_license.description",
        values: { inUse, productName },
        components: {
          enterpriseLink: /* @__PURE__ */ React.createElement(EnterpriseLink, null)
        }
      }
    )
  )));
};
export default MissingEnterpriseLicense;
